const messages = {
    en: {
        sidebarConstants: 'Constants',
        sidebarContents: 'Contents',
        sidebarMenuItems: 'Menu Items',
        sidebarDistributors: 'Distributors',
        sidebarSuppliers: 'Suppliers',
        sidebarRates: 'Rates',
        sidebarTranslations: 'Translations',
        sidebarUsers: 'Users',

        navbarLogout: 'Logout',
        navbarProfile: 'Profile',

        navigationButtonFinish: 'Finish',
        navigationButtonCancel: 'Cancel',
        navigationButtonBack: 'Back',

        modalDeleteTitle: 'Delete',
        modalDeleteText: 'Are you sure you want to delete this record?',

        modalUpdateTitle: 'Update',
        modalUpdateText: 'Are you sure you want to update this record?',

        modalConfirmTitle: 'Confirmation',
        modalConfirmText: 'Are you sure you want to confirm these rates?',

        modalRealtimeTitle: 'Are you sure you want to enable realtime updating of the menu?',
        modalRealtimeText: 'This feature will automatically update your site.',

        modalButtomConfirm: 'Confirm',
        modalButtonCancel: 'Cancel',

        selectInputPlaceholder: 'Select',
        tableActions: 'Actions',
        tooltipInfo: 'Click for more info',

        loginTitle: 'PCT-CMS',
        loginMessage: 'Log in to continue',
        loginEmail: 'E-mail',
        loginPassword: 'Password',
        loginButton: 'Login',
        loginBlankFieldWarning: 'You cannot leave any fields blank!',
        loginWrongCombinationWarning: 'User with these credentials does not exist!',

        notification: '',

        homeOverallRates: 'OVERALL RATES',
        homeRates: 'UNCONFIRMED RATES / CONFIRMED RATES',
        homeSuppliers: 'TOTAL NUMBER OF SUPPLIERS',

        constants: 'Constants',
        constantsSubtitle: 'Overview of constants',
        constantsButton: 'Create constant',
        constantsName: 'Name',
        constantsValue: 'Value',
        constantsActions: 'Actions',
        constantsCreate: 'Create new constant',
        constantsUpdate: 'Update constant',
        constantsFormName: 'Name',
        constantsFormValue: 'Value',

        contentsPageTitle: 'Content',
        contentsPageSubtitle: 'Overview of content',
        contentsButton: 'Create content',
        contentsTitle: 'Title',
        contentsSubtitle: 'Subtitle',
        contentsCreate: 'Create content',
        contentsUpdate: 'Update content',
        contentsText: 'Text',
        contentsView: 'Content Details',
        contentsViewCreatedAt: 'Created at',
        contentsViewUpdatedAt: 'Updated at',

        menuItemsPageTitle: 'Menu items',
        menuItemsPageSubtitle: 'Overview of menu items',
        menuItemsButton: 'Create menu',
        menuItemsPosition: 'Position',
        menuItemsDescription: 'Description',
        menuItemsCreate: 'Create menu',
        menuItemsUpdate: 'Update menu',
        menuItemsContents: 'Contents',
        menuItemsLink: 'Custom links',
        menuItemsName: 'Name',
        menuItemsAddButton: 'Add to menu',

        distributorsPageTitle: 'Distributors',
        distributorsPageSubtitle: 'Overview of distributors',
        distributorsButton: 'Create distributor',

        providerAvatar: 'Avatar',
        providerLegalName: 'Legal name',
        providerDisplayName: 'Display name',
        providerCity: 'City',
        providerProviderType: 'Provider type',

        distributorsCreate: 'Create distributos',
        distributorsUpdate: 'Update distributor',
        distributorsView: 'Distributor details',

        suppliersPageTitle: 'Suppliers',
        suppliersPageSubtitle: 'Overview of supliers',
        suppliersButton: 'Create supplier',

        suppliersCreate: 'Create supplier',
        suppliersUpdate: 'Update supplier',
        suppliersView: 'Supplier details',

        providerSelectUser: 'Select user',
        providerUser: 'User',
        providerSelectProvider: 'Select provider type',
        providerEmail: 'E-mail',
        providerPhone: 'Phone',
        providerFax: 'Fax',
        providerWeb: 'Web',
        providerAddress: 'Address',
        providerZip: 'Zip',
        providerDescription: 'Description',
        providerLogo: 'Logo',
        providerCreatedAt: 'Created at',
        providerUpdatedAt: 'Updated at',

        ratesPageTitle: 'Rates',
        ratesPageSubtitle: 'Overview of rates',
        ratesCreateSupplierRate: 'Create supplier rate',
        ratesCreateDistributorRate: 'Create distributor rate',

        ratesAutoconfirmButton: 'Autoconfirm',
        ratesConfirmButton: 'Confirm selected rates',
        ratesPublishButton: 'Publish selected rates',
        ratesProviderFilter: 'Provider filter',
        ratesDistributorFilter: 'Distributor filter',
        ratesCustomerTypeFilter: 'Customer filter',
        ratesMeterTypeFilter: 'Meter type filter',
        ratesSeasonTypeFilter: 'Season filter',
        ratesConfirmed: 'Confirmed',
        ratesProvider: 'Provider',
        ratesSelectProvider: 'Select provider',
        ratesDistributor: 'Distributor',
        ratesSelectDistributor: 'Select distributor',
        ratesCustomerType: 'Customer type',
        ratesSelectCustomerType: 'Select customer type',
        ratesSelectMeterType: 'Select meter type',
        ratesMeterType: 'Meter type',
        ratesSeasonType: 'Season type',
        ratesSelectSeasonType: 'Select season type',
        ratesActiveEnergy: 'Active energy',
        ratesReactiveEnergy: 'Reactive energy',
        ratesHT: 'HT',
        ratesLT: 'LT',
        ratesActiveEnergyHT: 'Active energy (HT)',
        ratesActiveEnergyLT: 'Active energy (LT)',
        ratesReactiveEnergyHT: 'Reactive energy (HT)',
        ratesReactiveEnergyLT: 'Reactive energy (LT)',
        ratesBillingCapacityHT: 'Billing capacity (HT)',
        ratesBillingCapacityLT: 'Billing capacity (LT)',
        ratesElectricity: 'Electricity',
        ratesCommonSpaces: 'Common spaces',
        ratesConsumption: 'Consupmtion',
        ratesDemandCharge: 'Demand charge',
        ratesEconomicDamage: 'Economic damage',
        ratesFixedTariff: 'Fixed tariff',
        ratesActive: 'Active',
        ratesReactive: 'Reactive',
        ratesDemandCharge: 'Demand charge',
        ratesRenewableEnergy: 'Renewable energy',
        ratesEnergyEfficiency: 'Energy Efficiency',
        ratesMeteringPoint: 'Metering point',
        ratesActions: 'Actions',
        ratesCreatedAt: 'Created at',
        ratesCreatedBy: 'Created by',

        rateCreate: 'Create provider rate',
        rateCreated: 'Create provider rate',
        rateUpdate: 'Update provider rate',

        // rateFormConfirm: 'Confirm',
        // rateFormProvider: 'Provider',
        // rateFormSupplier: 'Supplier',
        // rateFormDistributor: 'Distributor',
        // rateFormCustomerType: 'Customer type',
        // rateFormContractTerm: 'Contract term',
        // rateFormMeterType: 'Meter type',
        // rateFormSpecialOffer: 'Special offer',
        // rateFormCreatedAt: 'Created at',
        // rateFormCreatedBy: 'Created by',
        // rateFormUpdatedAt: 'Updated at',
        // rateFormUpdatedBy: 'Updated by',
        // rateFormConfirmedAt: 'Confirmed at',
        // rateFormConfirmedBy: 'Confirmed by',
        // rateFormPublishedAt: 'Published at',
        // rateFormTariffs: 'Tariffs',
        // rateFormActiveEnergyHT: 'Active energy (HT)',
        // rateFormActiveEnergyLT: 'Active energy (LT)',
        // rateFormReactiveEnergyHT: 'Reactive energy (HT)',
        // rateFormReactiveEnergyLT: 'Reactive energy (LT)',
        // rateFormCommonSpaces: 'Common spaces',
        // rateFormConsumption: 'Consumption',
        // rateFormDemandCharge: 'Demand charge',
        // rateFormEconomicDamage: 'Economic damage',
        // rateFormFixedTariff: 'Fixed tariff',
        // rateFormRenewableEnergySource: 'Renewable energy source',
        // rateFormActiveElectricity: 'Active electricity',
        // rateFormReactiveElectricity: 'Reactive electricity',
        // rateFormDemandCharge: 'Demand charge',
        // rateFormValidThrough: 'Valid through',
        // rateFormBillingCapacityHT: 'Billing capacity (HT)',
        // rateFormBillingCapacityLT: 'Billing capacity (LT)',
        // rateFormMeteringPoint: 'Metering Point',
        // rateFormRateType: 'Rate type',
        // rateTariffs: 'Tariffs',
        // rateFormUniversalService: 'Universal service',
        // rateFormLastResort: 'Last resort',
        // rateFormSeasonDescription: 'Season description',

        rateViewTitle: 'Provider rate details',
        rateViewConfirmed: 'Confirmed',
        // rateViewProvider: 'Provider',
        // rateViewDistributor: 'Distributor',
        // rateViewCustomerType: 'Customer type',
        // rateViewContractTerm: 'Contract term',
        // rateViewSpecialOffer: 'Special offer',
        // rateViewCreatedAt: 'Created at',
        // rateViewCreatedBy: 'Created by',
        // rateViewUpdatedAt: 'Updated at',
        // rateViewUpdatedBy: 'Updated by',
        // rateViewConfirmedAt: 'Confirmed at',
        // rateViewConfirmedBy: 'Confirmed by',
        // rateViewPublishedAt: 'Published at',
        // rateViewTariffs: 'Tariffs',
        // rateViewActiveEnergyHT: 'Active energy (HT)',
        // rateViewActiveEnergyLT: 'Active energy (LT)',
        // rateViewRenewableEnergySource: 'Renewable energy source',

        translationsPageTitle: 'Translatable',
        translationsPageSubtitle: 'Overview of translatable parts',
        translationsTitle: 'Title',
        translationsActions: 'Actions',
        translationUpdate: 'Update translation',

        usersTitle: 'Users',
        usersSubtitle: 'Overview of users',
        usersButton: 'Create user',
        usersTableName: 'Name',
        usersTableEmail: 'Email',
        usersTableRole: 'Role',
        usersTableActions: 'Actions',
        usersFormTitle: 'Create user',
        usersFormName: 'Name',
        usersFormEmail: 'Email',
        usersFormPassword: 'Password',
        usersFormPasswordConfirm: 'Confirm password',
        usersFormRole: 'Role',



        sidebarCustomerTypes: 'Customer types',
        customerTypesTitle: 'Customer types',
        customerTypesSubtitle: 'Overview of customer types',
        customerTypesName: 'Name',
        customerTypesDescription: 'Description',
        customerTypesButton: 'Create customer type',
        customerTypesCreate: 'Create customer type',
        customerTypesUpdate: 'Update customer type',
        ratesName: 'Name',
        ratesCreate: 'Create rate',
        ratesSelectPowerMeasurement: 'Select power measurement',
        ratesSelectContractTerm: 'Select contract term',
        ratesLossHT: 'Loss (HT)',
        ratesLossLT: 'Loss (LT)',
        ratesNetworkCapacity: 'Network capacity',
        ratesFixedNetworkCapacity: 'Fixed network capacity',
        ratesPowerMeasurement: 'Power measurement',
        ratesBillingCapacity: 'Billing capacity',
        ratesOIE: 'OIE',
        ratesOperator: 'Operator',
        ratesRenewable: 'Renewable',
        ratesValidityPeriod: 'Validity period',
        ratesSeasonDescription: 'Season description',
        // ratesConfirm: 'Confirm',
        // ratesDetails: 'Rate details',
        // ratesTariffs: 'Rate tariffs',
        // ratesContractTerm: 'Contract term',
        // ratesUpdatedAt: 'Updated at',
        // ratesConfirmedAt: 'Confirmed at',
        // ratesPublishedAt: 'Publishes at',
        // translationsCreate: 'Create translation',
        // translationCreate: 'Create translation',
        // translationsUpdate: 'Update translation',
        // translationsName: 'Name',
        // usersCreate: 'Create user',
        // usersUpdate: 'Update user',
        // usersName: 'Name',
        // usersEmail: 'Email',
        // usersRole: 'Role',
        // usersPassword: 'Password',
        // usersPasswordConfirm: 'Confirm password',
        userView: 'User details',
        usersProvider: 'Provider',
        userProfile: 'Profile',
    }
}

export default messages



// WEBPACK FOOTER //
// ./src/i18n/messages/lang.js